import { makeAutoObservable, runInAction } from 'mobx'
import { handleAxiosError } from '~/shared/lib'
import {
  AbandonedCartFiltersType,
  AbandonedCartLoadingType,
  AbandonedCartType,
} from './types'
import { AbandonedCartsService } from '~/shared/api/services/abandoned'

export class AbandonedCartsStore {
  abandonedCarts: AbandonedCartType[] = []

  loaders: AbandonedCartLoadingType = {
    abandonedCarts: false,
    loadMoreAbandonedCarts: false,
  }

  requestSettings = {
    limit: 20,
    offset: 0,
    isAllLoaded: false,
  }

  constructor() {
    makeAutoObservable(this)
  }

  activeLoader = (key: keyof AbandonedCartLoadingType) => {
    this.loaders = { ...this.loaders, [key]: true }
  }

  closeLoader = (key: keyof AbandonedCartLoadingType) => {
    this.loaders = { ...this.loaders, [key]: false }
  }

  getAbandonedCarts = async (options?: {
    action?: 'loadMoreAbandonedCarts'
    filters?: AbandonedCartFiltersType
  }) => {
    const { action, filters } = options || {}

    if (
      action === 'loadMoreAbandonedCarts' &&
      this.requestSettings.isAllLoaded
    ) {
      return
    }

    this.activeLoader(action || 'abandonedCarts')

    try {
      const params = {
        limit: this.requestSettings.limit,
        offset:
          action !== 'loadMoreAbandonedCarts' ? 0 : this.requestSettings.offset,
        ...filters,
      }

      const { data } = await AbandonedCartsService.getAbandonedCarts({ params })

      if (action === 'loadMoreAbandonedCarts') {
        runInAction(() => {
          this.abandonedCarts = [...this.abandonedCarts, ...data]
        })
      } else {
        runInAction(() => {
          this.abandonedCarts = data
        })
      }

      runInAction(() => {
        this.requestSettings = {
          ...this.requestSettings,
          isAllLoaded: data.length < this.requestSettings.limit,
          offset:
            action === 'loadMoreAbandonedCarts'
              ? this.requestSettings.offset + this.requestSettings.limit
              : this.requestSettings.limit,
        }
      })

      return data
    } catch (error) {
      const errorMessage = handleAxiosError(error)
      throw new Error(errorMessage)
    } finally {
      this.closeLoader(action || 'abandonedCarts')
    }
  }

  resetPagination = () => {
    this.requestSettings = {
      limit: 20,
      offset: 0,
      isAllLoaded: false,
    }
  }
}
